import type { ConsentEventPayload, Purpose } from "./types";

export const toSubmitPurposes = (
  purposes: ReadonlyArray<Purpose>
): ConsentEventPayload["purposes"] =>
  purposes.map((purpose) => {
    if (!purpose.uuid) {
      throw new Error("Invalid purpose data: missing uuid");
    }

    const dataElements = (purpose.data_elements || [])
      .filter((element) => element.enabled)
      .map((element) => ({
        uuid: element.uuid,
        selected: element.required ? true : Boolean(element.selected),
      }));

    return {
      purpose_uuid: purpose.uuid,
      ...(purpose.product_uuid ? { product_uuid: purpose.product_uuid } : {}),
      selected: Boolean(purpose.selected),
      data_elements: dataElements.length > 0 ? dataElements : undefined,
    };
  });
